<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>

    <div class="user-info">
      <a :aria-expanded="!isClosed" data-toggle="collapse" @click.stop="toggleMenu" @click.capture="clicked">
        <span>{{ title }}<b class="caret"/></span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#vue">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li>
              <li>
                <a href="#vue">
                  <span class="sidebar-mini">EP</span>
                  <span class="sidebar-normal">Edit Profile</span>
                </a>
              </li>
              <li>
                <a href="#vue">
                  <span class="sidebar-mini">S</span>
                  <span class="sidebar-normal">Settings</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions"

export default {
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: "User Name"
    },
    avatar: {
      type: String,
      default: "http://via.placeholder.com/400/3b3b3b/3b3b3b/?text=." //"./img/faces/avatar.jpg"
    }
  },
  data() {
    return {
      isClosed: true
    }
  },
  methods: {
    clicked: function(e) {
      e.preventDefault()
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed
    }
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
